var Component = require("!../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-16b9f21d\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MentoringBagIcon.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/bag/MentoringBagIcon.vue
// module id = 8151f1b2d4f13c9d2495
// module chunks = 89